
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91slug_936AefRVMWT2Meta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/blog/[slug].vue?macro=true";
import { default as indexEjsTdIgetSMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/blog/index.vue?macro=true";
import { default as indexzbtVURIXzDMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/changelog/index.vue?macro=true";
import { default as index39TGiZHYXkMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/customer-home/index.vue?macro=true";
import { default as _91slug_93LHOawc1ZWYMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/enterprise/[slug].vue?macro=true";
import { default as _91slug_93GjakoYDXU2Meta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/events/[slug].vue?macro=true";
import { default as _91slug_93kz0MF6DNqaMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/features/[slug].vue?macro=true";
import { default as _91slug_93UtNu4Yzm54Meta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/includes/signup-partials/[slug].vue?macro=true";
import { default as indexHgGjT2N2HwMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/index.vue?macro=true";
import { default as index9L8ypBYpNnMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/platform/index.vue?macro=true";
import { default as indexmuHyUuPkYWMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/pricing/index.vue?macro=true";
import { default as indexx8ABfnfTioMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/refer-a-friend/index.vue?macro=true";
import { default as _91slug_93F3EIv6wQ0dMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/resource-center/case-studies/[slug].vue?macro=true";
import { default as indexvT1feh9QFIMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/resource-center/case-studies/index.vue?macro=true";
import { default as indexgFC5PNcBqLMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/resource-center/events/index.vue?macro=true";
import { default as indexLhnmxw2TrpMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/resource-center/index.vue?macro=true";
import { default as _91slug_93rxwhBPBgJKMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/resource-center/tech-tips/[slug].vue?macro=true";
import { default as indexU2gBF3baaEMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/resource-center/tech-tips/index.vue?macro=true";
import { default as _91slug_93jOTlezeKELMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/resource-center/videos/[slug].vue?macro=true";
import { default as indexxJV2kg7xG5Meta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/resource-center/videos/index.vue?macro=true";
import { default as _91slug_9313QpKGioSmMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/resource-center/what-is-new/[slug].vue?macro=true";
import { default as indexWrPIY1spcPMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/resource-center/what-is-new/index.vue?macro=true";
import { default as _91slug_93wsU3QX0g1vMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/spotlight/[slug].vue?macro=true";
import { default as indexBm99aYIJgPMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/spotlight/index.vue?macro=true";
import { default as indexZUB9nDiEaIMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/why-onshape/index.vue?macro=true";
import { default as _404oe8PAiesdYMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/404.vue?macro=true";
import { default as baseMlzT1rgwZ0Meta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/base.vue?macro=true";
import { default as genericNJP7J0aiJXMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue?macro=true";
import { default as microSiteowZdW5nvlJMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/microSite.vue?macro=true";
import { default as personalizedGeneric6VNm0UcU2RMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/personalizedGeneric.vue?macro=true";
import { default as indexX5c6Jl7KIYMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/iframe/sign-in/general/index.vue?macro=true";
import { default as indexTLcDqcMYBeMeta } from "/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/index.vue?macro=true";
export default [
  {
    name: "lang-blog-slug",
    path: "/:lang()/blog/:slug()",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/blog/[slug].vue")
  },
  {
    name: "lang-blog",
    path: "/:lang()/blog",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/blog/index.vue")
  },
  {
    name: "lang-changelog",
    path: "/:lang()/changelog",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/changelog/index.vue")
  },
  {
    name: "lang-customer-home",
    path: "/:lang()/customer-home",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/customer-home/index.vue")
  },
  {
    name: "lang-enterprise-slug",
    path: "/:lang()/enterprise/:slug()",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/enterprise/[slug].vue")
  },
  {
    name: "lang-events-slug",
    path: "/:lang()/events/:slug()",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/events/[slug].vue")
  },
  {
    name: "lang-features-slug",
    path: "/:lang()/features/:slug()",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/features/[slug].vue")
  },
  {
    name: "lang-includes-signup-partials-slug",
    path: "/:lang()/includes/signup-partials/:slug()",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/includes/signup-partials/[slug].vue")
  },
  {
    name: "lang",
    path: "/:lang()",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/index.vue")
  },
  {
    name: "lang-platform",
    path: "/:lang()/platform",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/platform/index.vue")
  },
  {
    name: "lang-pricing",
    path: "/:lang()/pricing",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/pricing/index.vue")
  },
  {
    name: "lang-refer-a-friend",
    path: "/:lang()/refer-a-friend",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/refer-a-friend/index.vue")
  },
  {
    name: "lang-resource-center-case-studies-slug",
    path: "/:lang()/resource-center/case-studies/:slug()",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/resource-center/case-studies/[slug].vue")
  },
  {
    name: "lang-resource-center-case-studies",
    path: "/:lang()/resource-center/case-studies",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/resource-center/case-studies/index.vue")
  },
  {
    name: "lang-resource-center-events",
    path: "/:lang()/resource-center/events",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/resource-center/events/index.vue")
  },
  {
    name: "lang-resource-center",
    path: "/:lang()/resource-center",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/resource-center/index.vue")
  },
  {
    name: "lang-resource-center-tech-tips-slug",
    path: "/:lang()/resource-center/tech-tips/:slug()",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/resource-center/tech-tips/[slug].vue")
  },
  {
    name: "lang-resource-center-tech-tips",
    path: "/:lang()/resource-center/tech-tips",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/resource-center/tech-tips/index.vue")
  },
  {
    name: "lang-resource-center-videos-slug",
    path: "/:lang()/resource-center/videos/:slug()",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/resource-center/videos/[slug].vue")
  },
  {
    name: "lang-resource-center-videos",
    path: "/:lang()/resource-center/videos",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/resource-center/videos/index.vue")
  },
  {
    name: "lang-resource-center-what-is-new-slug",
    path: "/:lang()/resource-center/what-is-new/:slug()",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/resource-center/what-is-new/[slug].vue")
  },
  {
    name: "lang-resource-center-what-is-new",
    path: "/:lang()/resource-center/what-is-new",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/resource-center/what-is-new/index.vue")
  },
  {
    name: "lang-spotlight-slug",
    path: "/:lang()/spotlight/:slug()",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/spotlight/[slug].vue")
  },
  {
    name: "lang-spotlight",
    path: "/:lang()/spotlight",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/spotlight/index.vue")
  },
  {
    name: "lang-why-onshape",
    path: "/:lang()/why-onshape",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/[lang]/why-onshape/index.vue")
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/404.vue")
  },
  {
    name: "dynamic-base",
    path: "/dynamic/base",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/base.vue")
  },
  {
    name: "dynamic-generic",
    path: "/dynamic/generic",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "dynamic-microSite",
    path: "/dynamic/microSite",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/microSite.vue")
  },
  {
    name: "dynamic-personalizedGeneric",
    path: "/dynamic/personalizedGeneric",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/personalizedGeneric.vue")
  },
  {
    name: "iframe-sign-in-general",
    path: "/iframe/sign-in/general",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/iframe/sign-in/general/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/index.vue")
  },
  {
    name: "en-startups-",
    path: "/:lang()/startups/",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/microSite.vue")
  },
  {
    name: "en-solidworks-data-migration-",
    path: "/:lang()/solidworks-data-migration/",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/microSite.vue")
  },
  {
    name: "en-features-custom-features",
    path: "/:lang()/features/custom-features",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-lp-pcb-studio-altium-connector",
    path: "/:lang()/lp/pcb-studio-altium-connector",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-education-courses-curriculum",
    path: "/:lang()/education/courses-curriculum",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/microSite.vue")
  },
  {
    name: "en-accept-referral",
    path: "/:lang()/accept-referral",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-lp-onshape-government",
    path: "/:lang()/lp/onshape-government",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-education-plans",
    path: "/:lang()/education/plans",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/microSite.vue")
  },
  {
    name: "en-legal-terms-of-use",
    path: "/:lang()/legal/terms-of-use",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-solutions-medical-device-design",
    path: "/:lang()/solutions/medical-device-design",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-solutions-hardware-startups",
    path: "/:lang()/solutions/hardware-startups",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-solutions-robotics",
    path: "/:lang()/solutions/robotics",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-lp-bell-crank-ja",
    path: "/:lang()/lp/bell-crank-ja",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-education-",
    path: "/:lang()/education/",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/microSite.vue")
  },
  {
    name: "en-solutions-energy-and-utilities-design",
    path: "/:lang()/solutions/energy-and-utilities-design",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-solidworks-data-migration-how-to-migrate-to-onshape",
    path: "/:lang()/solidworks-data-migration/how-to-migrate-to-onshape",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/microSite.vue")
  },
  {
    name: "en-startups-why-onshape",
    path: "/:lang()/startups/why-onshape",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/microSite.vue")
  },
  {
    name: "en-standard",
    path: "/:lang()/standard",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-solutions-machine-design",
    path: "/:lang()/solutions/machine-design",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-feature-comparison-solidworks",
    path: "/:lang()/feature-comparison/solidworks",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-legal-",
    path: "/:lang()/legal/",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-lp-creator-program",
    path: "/:lang()/lp/creator-program",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-solutions-aerospace-defense",
    path: "/:lang()/solutions/aerospace-defense",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-lp-upgrade-render-studio",
    path: "/:lang()/lp/upgrade-render-studio",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-legal-trademarks",
    path: "/:lang()/legal/trademarks",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-lp-what-is-onshape-ja",
    path: "/:lang()/lp/what-is-onshape-ja",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-startups-partners",
    path: "/:lang()/startups/partners",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/microSite.vue")
  },
  {
    name: "en-startups-entrepreneur-reapply",
    path: "/:lang()/startups/entrepreneur-reapply",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/microSite.vue")
  },
  {
    name: "en-contact-sales",
    path: "/:lang()/contact-sales",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-lp-onshape-cam-studio-advanced",
    path: "/:lang()/lp/onshape-cam-studio-advanced",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-lp-change-settings-ja",
    path: "/:lang()/lp/change-settings-ja",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-home-ja",
    path: "/:lang()/home-ja",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-domain-whitelisting",
    path: "/:lang()/domain-whitelisting",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-education-collegiate-teams",
    path: "/:lang()/education/collegiate-teams",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/microSite.vue")
  },
  {
    name: "en-lp-sign-up-de",
    path: "/:lang()/lp/sign-up-de",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-features-onshape-vision-operating-instructions",
    path: "/:lang()/features/onshape-vision/operating-instructions",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-sign-up",
    path: "/:lang()/sign-up",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/base.vue")
  },
  {
    name: "en-startups-apply",
    path: "/:lang()/startups/apply",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/microSite.vue")
  },
  {
    name: "en-solutions-electronics-design",
    path: "/:lang()/solutions/electronics-design",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-lp-onshape-cam",
    path: "/:lang()/lp/onshape-cam",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-demo-request",
    path: "/:lang()/demo-request",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-education-sign-up",
    path: "/:lang()/education/sign-up",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/microSite.vue")
  },
  {
    name: "en-privacy-center-",
    path: "/:lang()/privacy-center/",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-design",
    path: "/:lang()/design",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-lp-3d-cad-free-trial-ad",
    path: "/:lang()/lp/3d-cad-free-trial-ad",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-professional-trial",
    path: "/:lang()/professional-trial",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-lp-reactivate-discovery-trial",
    path: "/:lang()/lp/reactivate-discovery-trial",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-lp-switch-from-solidworks-to-onshape",
    path: "/:lang()/lp/switch-from-solidworks-to-onshape",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-solutions-consumer-products",
    path: "/:lang()/solutions/consumer-products",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-enterprise-faq",
    path: "/:lang()/enterprise/faq",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/microSite.vue")
  },
  {
    name: "en-education-cam-for-first",
    path: "/:lang()/education/cam-for-first",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-education-first-robotics",
    path: "/:lang()/education/first-robotics",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/microSite.vue")
  },
  {
    name: "en-products-free",
    path: "/:lang()/products/free",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-demo-request-arena",
    path: "/:lang()/demo-request-arena",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-education-robotics",
    path: "/:lang()/education/robotics",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/microSite.vue")
  },
  {
    name: "en-internal-internal-lead-referral-form",
    path: "/:lang()/internal/internal-lead-referral-form",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-education-educator-upgrade",
    path: "/:lang()/education/educator-upgrade",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-features-onshape-vision",
    path: "/:lang()/features/onshape-vision",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-enterprise-",
    path: "/:lang()/enterprise/",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/microSite.vue")
  },
  {
    name: "en-startups-faq",
    path: "/:lang()/startups/faq",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/microSite.vue")
  },
  {
    name: "en-education-enterprise-processing",
    path: "/:lang()/education/enterprise-processing",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-contact",
    path: "/:lang()/contact",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-education-enterprise",
    path: "/:lang()/education/enterprise",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/microSite.vue")
  },
  {
    name: "en-lp-sign-up",
    path: "/:lang()/lp/sign-up",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-pgp-key",
    path: "/:lang()/pgp-key",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-education-science-olympiad",
    path: "/:lang()/education/science-olympiad",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/microSite.vue")
  },
  {
    name: "en-test",
    path: "/:lang()/test",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-legal-",
    path: "/:lang()/legal/",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "",
    path: "",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-ai-advisor",
    path: "/:lang()/ai-advisor",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-lp-sign-up-de-test",
    path: "/:lang()/lp/sign-up-de-test",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-lp-component-guide",
    path: "/:lang()/lp/component-guide",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-solutions-industrial-equipment-and-machine-design",
    path: "/:lang()/solutions/industrial-equipment-and-machine-design",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-education-first-robotics-error",
    path: "/:lang()/education/first-robotics-error",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/microSite.vue")
  },
  {
    name: "en-pgp-key",
    path: "/:lang()/pgp-key",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-legal-gov-terms-of-use",
    path: "/:lang()/legal/gov-terms-of-use",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-preference-center",
    path: "/:lang()/preference-center",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-solutions-automotive-design",
    path: "/:lang()/solutions/automotive-design",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-legal-data-disclosures",
    path: "/:lang()/legal/data-disclosures",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  },
  {
    name: "en-lp-upgrade-to-pro-from-standard",
    path: "/:lang()/lp/upgrade-to-pro-from-standard",
    component: () => import("/shared/app/build/enabled/production/ssg/www/mod/momentum/pages/dynamic/generic.vue")
  }
]